import { ReadOnlyField } from '@app/components/various/Fields/ReadOnlyField';
import { FieldLabel } from '@app/components/various/Form';
import { getCheckoutFields } from '@app/ducks';
import { Dates } from '@typings';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  additionalNotes: string | undefined;
  estimatedShippingDate: false | Dates.DateAsSQLString | undefined;
}

export const CheckoutSuccessAdditionalInformation = ({ additionalNotes = '', estimatedShippingDate }: Props) => {
  const { t } = useTranslation(['checkout']);
  const checkoutFields = useSelector(getCheckoutFields);

  const shouldShowAdditionalNotes = 'additionalNotes' in checkoutFields;
  const shippingDateValue = typeof estimatedShippingDate === 'string' ? estimatedShippingDate : '-';

  return (
    <div className="box">
      <h3 className="mb-5 heading-3">{t('checkout:additional_info')}</h3>
      <div className="flex w-full flex-col gap-5">
        {shouldShowAdditionalNotes && (
          <FieldLabel label={t('checkout:additional_notes')}>
            <ReadOnlyField>{additionalNotes || '-'}</ReadOnlyField>
          </FieldLabel>
        )}
        <FieldLabel label={t('checkout:estimated_delivery_date')}>
          <ReadOnlyField>{shippingDateValue}</ReadOnlyField>
        </FieldLabel>
      </div>
    </div>
  );
};
